export default __webpack_public_path__ + "img/dxszPZLt.0cff311a.svg";